import { AgGridService } from "@topline/services/agGridService";
import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";
import { GridValueEditorService } from "./service/gridValueEditorService";
(module => {
    module.component("gridValueEditor", {
        template: require("./gridValueEditorComponent.html"),
        bindings: {
            gridOptions: "=",
            showInMilions: "<",
            notifyAboutChanges: "&",
            gridDataChanged: "=",
            gridSumOutside: "<"
        },
        controller: [
            "GirdValudEditorHeader",
            GridValueEditorService.componentName,
            "$scope",
            "$filter",
            angularServicesNames.$translate,
            AgGridService.componentName,
            ToasterService.componentName,
            FileDownloadService.componentName,
            "$interpolate",
            function (
                this: $TSFixMe,
                GirdValudEditorHeader: $TSFixMe,
                gridValueEditorService: GridValueEditorService,
                $scope: $TSFixMe,
                $filter: ng.IFilterService,
                $translate: ng.translate.ITranslateService,
                agGridService: AgGridService,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                $interpolate: ng.IInterpolateService
            ) {
                const $ctrl = this;
                $ctrl.showInMilions = false;
                $ctrl.updateFromPaste = false;
                $ctrl.showSpecialElement = false;
                $ctrl.gridValueEditorService = gridValueEditorService;

                $ctrl.additionalParameters = {
                    footerData: false,
                    needToMultiplyValues: true,
                    footerDataHeader: ""
                };

                function initGrids(this: $TSFixMe) {
                    $ctrl.editorGridOptions = {
                        columnDefs: generateColumnDefs("main"),
                        localeTextFunc: agGridService.transalteFunc,
                        domLayout: "autoHeight",
                        animateRows: true,
                        defaultColDef: {
                            sortable: false,
                            filter: false,
                            resizable: false,
                            width: $ctrl.gridOptions.cellWidth || 100,
                            suppressMovable: true,
                            suppressMenu: true,
                            editable: (params: $TSFixMe) =>
                                !params.data.readOnly &&
                                !$ctrl.gridOptions.readOnly &&
                                ($ctrl.gridOptions.readOnlyCells == null ||
                                    params.colDef.columnIndex >= $ctrl.gridOptions.readOnlyCells),
                            cellClass: (params: $TSFixMe) =>
                                $ctrl.gridOptions.showReadonlyCellsAsAlert &&
                                params.colDef.columnIndex < $ctrl.gridOptions.readOnlyCells &&
                                !params.data.readOnly
                                    ? "grid-freezed-cells"
                                    : ""
                        },
                        angularCompileRows: true,
                        popupParent: document.querySelector("body"),
                        enableRangeSelection: true,
                        rowHeight: 30,
                        headerHeight: 40,
                        rowGroupPanelShow: "never",
                        stopEditingWhenGridLosesFocus: true,
                        groupSuppressAutoColumn: true,
                        onRangeSelectionChanged: (event: $TSFixMe) => {
                            if ($ctrl.gridSumOutside) {
                                const rangeSelections = event.api.getRangeSelections(),
                                    singleRange = rangeSelections ? rangeSelections[0] : null,
                                    start = !angular.isUndefinedOrNull(singleRange)
                                        ? Math.min(singleRange.start.rowIndex, singleRange.end.rowIndex)
                                        : null,
                                    end = !angular.isUndefinedOrNull(singleRange)
                                        ? Math.max(singleRange.start.rowIndex, singleRange.end.rowIndex)
                                        : null;

                                $ctrl.dataToResume = [];

                                if (!angular.isUndefinedOrNull(start) && !angular.isUndefinedOrNull(end)) {
                                    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                                    for (let i = start, max = end; i <= max; i++) {
                                        let sum = 0;
                                        let item = {};
                                        const rowModel = event.api.getModel(),
                                            rowNode = rowModel.getRow(i);
                                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type '{}'.
                                        item.title = rowNode.data.header;

                                        singleRange.columns.forEach((x: $TSFixMe) => {
                                            const value = event.api.getValue(x, rowNode);
                                            if (typeof value === "number") {
                                                sum += value;
                                            }
                                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'sum' does not exist on type '{}'.
                                            item.sum = sum;
                                        });
                                        $ctrl.dataToResume.push(item);
                                    }
                                    $ctrl.showSpecialElement = !!$ctrl.dataToResume.length;
                                    $scope.$apply();
                                }
                            }
                        },
                        suppressHorizontalScroll: $ctrl.gridOptions.showFooter,
                        processDataFromClipboard: (params: $TSFixMe) => {
                            $ctrl.updateFromPaste = true;
                            return params.data;
                        },
                        onPasteEnd: () => {
                            $ctrl.updateFromPaste = false;
                            for (const row of $ctrl.gridOptions.gridData) {
                                $ctrl.notifyAboutChanges({ value: row.values, row: row });
                            }
                        },
                        context: {
                            thisComponent: $ctrl
                        },
                        getRowStyle: (params: $TSFixMe) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: "whiteSmoke" };
                            }
                        },
                        // @ts-expect-error ts-migrate(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
                        context: {
                            thisComponent: this
                        },
                        onGridReady: (e: $TSFixMe) => {
                            $ctrl.gridApi = e.api;
                            $ctrl.columnApi = e.columnApi;
                            loadData();
                        },
                        alignedGrids: []
                    };

                    if ($ctrl.gridOptions && $ctrl.gridOptions.showFooter) {
                        $ctrl.footerGridOptions = {
                            columnDefs: generateColumnDefs("footer"),
                            popupParent: document.querySelector("body"),
                            defaultColDef: {
                                sortable: false,
                                filter: false,
                                resizable: false,
                                width: $ctrl.gridOptions.cellWidth || 100,
                                suppressMenu: true,
                                rowHeight: 30,
                                suppressMovable: true,
                                cellStyle: { textAlign: "right" },
                                editable: false,
                                cellClass: (params: $TSFixMe) => {
                                    if (
                                        $ctrl.gridOptions.validateFotter &&
                                        params.value !== null &&
                                        (params.value - 100 > 0.005 || params.value - 100 < -0.005)
                                    ) {
                                        return "grid-sum-validation-error";
                                    }
                                    return "";
                                }
                            },
                            onGridReady: (e: $TSFixMe) => {
                                $ctrl.footerGridApi = e.api;
                                if ($ctrl.gridOptions.footerData) {
                                    $ctrl.footerGridApi.setRowData([$ctrl.gridOptions.footerData]);
                                }
                            },
                            headerHeight: 0,
                            alignedGrids: []
                        };
                        $ctrl.editorGridOptions.alignedGrids.push($ctrl.footerGridOptions);
                        $ctrl.footerGridOptions.alignedGrids.push($ctrl.editorGridOptions);
                    }
                }

                function loadData() {
                    if ($ctrl.gridOptions) {
                        $ctrl.gridApi.setRowData($ctrl.gridOptions.gridData);
                    }
                }

                function generateColumnDefs(type: $TSFixMe) {
                    if (!$ctrl.gridOptions) return [];

                    const isYearlyGird = angular.isNumber($ctrl.gridOptions.header[0]);
                    if (isYearlyGird) {
                        return generateYearlyColumns(type == "footer");
                    } else {
                        return generateMonthlyColumns(type == "footer" ? createFooterColumn : createColumn);
                    }
                }

                function generateYearlyColumns(isFotter: $TSFixMe) {
                    let columns = $ctrl.gridOptions.header.map((year: $TSFixMe, index: $TSFixMe) => {
                        return {
                            colId: "" + year,
                            headerName: year,
                            columnIndex: index,
                            valueGetter: (params: $TSFixMe) => getCellValue(index, params.data),
                            valueFormatter: (params: $TSFixMe) =>
                                formatValue(
                                    params.value,
                                    isFotter ? $ctrl.gridOptions.fotterSpecialEnd : $ctrl.gridOptions.valuesSpecialEnd
                                ),
                            valueSetter: (params: $TSFixMe) => setValue(params, index)
                        };
                    });
                    columns.unshift({
                        colId: "first-column",
                        pinned: "left",
                        lockPinned: true,
                        editable: false,
                        cellClass: () => "",
                        cellRenderer: (params: $TSFixMe) => (params.data ? params.data.header : null),
                        width: 250
                    });
                    return columns;
                }

                function generateMonthlyColumns(createColumnFunc: $TSFixMe) {
                    let columns = [
                        {
                            headerComponent: GirdValudEditorHeader,
                            cellStyle: {},
                            colId: "first-column",
                            pinned: "left",
                            lockPinned: true,
                            editable: false,
                            resizable: true,
                            cellClass: () => "",
                            cellRenderer: (params: $TSFixMe) => (params.data ? params.data.header : null),
                            headerComponentParams: {
                                showPropagateButton: $ctrl.gridOptions.showPropagateButton,
                                $ctrl
                            },
                            width: 250
                        }
                    ];

                    const headers = $ctrl.gridOptions.header[0];
                    let startMonthIndex = 0;
                    for (let i = 0; i < headers.headerLevel.length; i++) {
                        const colspan = headers.colspan[i];
                        columns.push({
                            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ headerName: any; children: any... Remove this comment to see the full error message
                            headerName: headers.headerLevel[i],

                            children: _.chain($ctrl.gridOptions.header[1].headerLevel)
                                .rest(startMonthIndex)
                                .first(headers.colspan[i])
                                .map((header: $TSFixMe, j: $TSFixMe) => {
                                    const index = startMonthIndex + j;
                                    const month = headers;
                                    return createColumnFunc(header, index, headers.headerLevel[i], 13 - colspan + j);
                                })
                                .value()
                        });
                        startMonthIndex += headers.colspan[i];
                    }

                    return columns;
                }

                function createColumn(header: $TSFixMe, index: $TSFixMe, year: $TSFixMe, month: $TSFixMe) {
                    return {
                        colId: `${year}_${month}`,
                        headerValueGetter: () => $translate.instant(header),
                        columnIndex: index,
                        valueGetter: (params: $TSFixMe) => getCellValue(index, params.data),
                        valueFormatter: (params: $TSFixMe) =>
                            formatValue(params.value, $ctrl.gridOptions.valuesSpecialEnd),
                        valueSetter: (params: $TSFixMe) => setValue(params, index)
                    };
                }

                function parseInput(input: $TSFixMe) {
                    return parseFloat(typeof input === "string" ? input.replace(",", ".").replace(" ", "") : input);
                }

                function createFooterColumn(header: $TSFixMe, index: $TSFixMe, year: $TSFixMe, month: $TSFixMe) {
                    return {
                        header: "",
                        colId: `${year}_${month}`,
                        valueGetter: (params: $TSFixMe) => params.data[index],
                        valueFormatter: (params: $TSFixMe) =>
                            formatValue(
                                params.value,
                                $ctrl.gridOptions.fotterSpecialEnd || $ctrl.gridOptions.valuesSpecialEnd
                            )
                    };
                }

                function formatValue(value: $TSFixMe, specialEnd: $TSFixMe) {
                    if ($ctrl.showInMilions) {
                        return ($filter("numberInMilions") as $TSFixMe)(
                            value,
                            $ctrl.gridOptions.valuesDecimalPlaces || 0
                        );
                    } else if (specialEnd == "%") {
                        return ($filter("percentage") as $TSFixMe)(value, $ctrl.gridOptions.valuesDecimalPlaces || 0);
                    } else if (!specialEnd) {
                        return $filter("number")(value, $ctrl.gridOptions.valuesDecimalPlaces || 0);
                    } else {
                        return $filter("number")(value, $ctrl.gridOptions.valuesDecimalPlaces || 0) + specialEnd;
                    }
                }

                function getCellValue(i: $TSFixMe, data: $TSFixMe) {
                    const historicalValuesLength = angular._get(data, "historicalValues.length", 0);
                    if (historicalValuesLength > 0 && i < historicalValuesLength) {
                        return data.historicalValues[i];
                    } else {
                        return data.values[i - historicalValuesLength];
                    }
                }

                function setValue(params: $TSFixMe, index: $TSFixMe) {
                    const value = parseInput(params.newValue);
                    if (isNaN(value)) {
                        return false;
                    } else {
                        if ($ctrl.updateFromPaste) {
                            const valueIndex =
                                params.data.historicalValues && params.data.historicalValues.length
                                    ? index - params.data.historicalValues.length
                                    : index;
                            params.data.values[valueIndex] = value;
                        } else {
                            $ctrl.gridOptions.updateCell(value, index, params.data);
                        }
                        return true;
                    }
                }

                $ctrl.$onInit = () => {
                    if ($ctrl.gridSumOutside) {
                        initWatchOutsideClick();
                    }
                    $scope.$watch("$ctrl.gridOptions", () => {
                        if ($ctrl.gridOptions) {
                            initGrids();
                        }
                    });

                    $scope.$watch("$ctrl.gridOptions.readOnlyCells", () => {
                        if ($ctrl.gridApi) {
                            $ctrl.gridApi.redrawRows();
                        }
                    });

                    $scope.$watch("$ctrl.gridOptions.gridData", (data: $TSFixMe) => {
                        if (data && $ctrl.gridApi) {
                            $ctrl.gridApi.setRowData(data);
                        }
                    });

                    $scope.$watch("$ctrl.gridOptions.footerData", (data: $TSFixMe) => {
                        if (data && $ctrl.footerGridApi) {
                            $ctrl.footerGridApi.setRowData([data]);
                        }
                    });
                };

                $ctrl.togglePropagate = () => {
                    $ctrl.gridOptions.propagateData = !$ctrl.gridOptions.propagateData;
                };

                $ctrl.scrollTo = (year: $TSFixMe, index: $TSFixMe, firstYearColSpan: $TSFixMe) => {
                    const lastColumn = gridValueEditorService.parseColId(_.last($ctrl.columnApi.getAllGridColumns()));

                    if (index == 0) {
                        $ctrl.gridApi.ensureColumnVisible(`${year}_${13 - firstYearColSpan}`);
                    } else if (year >= lastColumn.year) {
                        $ctrl.gridApi.ensureColumnVisible(`${lastColumn.year}_${lastColumn.month}`);
                    } else {
                        $ctrl.gridApi.ensureColumnVisible(`${year}_1`);
                    }
                };

                $ctrl.export = (optionalObj: $TSFixMe) => {
                    const exportColumns = $ctrl.gridOptions.header[0].headerFormatToExport || $ctrl.gridOptions.header;
                    let exportRows: $TSFixMe = [];

                    let additionalParameters = optionalObj ? optionalObj : $ctrl.additionalParameters;

                    if ($ctrl.gridOptions.valuesSpecialEnd === "%") {
                        angular.forEach($ctrl.gridOptions.gridData, (item: $TSFixMe) => {
                            let row = {
                                header: $interpolate(item.header)(null),
                                isPercentage: true,
                                decimalPlaces: $ctrl.gridOptions.valuesDecimalPlaces || 0,

                                values: _.map(
                                    (item.historicalValues || []).concat(item.values.slice()),
                                    (x: $TSFixMe) => x + "%"
                                )
                            };
                            exportRows.push(row);
                        });
                    } else {
                        exportRows = angular.copy($ctrl.gridOptions.gridData);
                        for (const row of exportRows) {
                            row.decimalPlaces = $ctrl.gridOptions.valuesDecimalPlaces || 0;
                            row.values = (row.historicalValues || []).concat(row.values);
                        }
                        exportRows = exportRows;
                    }
                    if (additionalParameters.footerData) {
                        exportRows.push({
                            header: additionalParameters.footerDataHeader,
                            values: $ctrl.gridOptions.footerData
                        });
                    }
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: exportColumns,
                                rows: exportRows
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };
                $ctrl.setPropagateData = (value: $TSFixMe) => {
                    $scope.$apply(() => ($ctrl.gridOptions.propagateData = value));
                };
                $ctrl.$onDestroy = () => {
                    document.body.removeEventListener("mouseup", handleClickOutside);
                };
                function initWatchOutsideClick() {
                    const body = document.body;

                    body.addEventListener("mouseup", handleClickOutside);
                }

                function handleClickOutside(e: $TSFixMe) {
                    const grid = document.getElementsByClassName("value-editor-wrapper");
                    if (!grid[0].contains(e.target)) {
                        $ctrl.gridApi.clearRangeSelection();
                        $ctrl.showSpecialElement = false;
                        $scope.$apply();
                    }
                }
            }
        ]
    });
})(angular.module("gridValueEditor"));
